export default {
  fr: {
    all: {
      orderForm: 'bon de commande',
      sepa: 'mandat SEPA',
      bank_card: 'carte de crédit',
      price: 'prix',
      loading: 'Chargement...',
      name: 'nom',
      description: 'description',
      paymentMethod: 'mode de paiement',
      shippingPrice: 'frais de port',
      shippingPriceForYourCountry: 'frais de port pour le pays sélectionné',
      testSubmitPayment: 'MODE TEST : simuler paiement',
      cancelOrderConfirmMessage: 'Confirmez-vous l\'annulation de votre commande ?',
      paymentErrorMessage: 'Une erreur est survenue durant le paiement. Merci de réessayer.',
      defaultOopsButtonLabel: 'J\'annule ma commande précédente',
      defaultValidation1cButtonLabel: 'Cliquez ici pour valider que vous êtes bien un humain',
      expiredMessage: 'Désolé, votre commande a déjà été traitée. Vous ne pouvez plus la modifier.',
      testEnabled: 'Vous utilisez actuellement Vanguard avec le paramètre testLevel=',
      previewEnable: 'Attention : Cette page est l\'aperçu d\'un BDC actuellement expiré',
      recaptureOk: 'Votre moyen de paiement a bien été mis à jour',
      regularizeOk: 'Votre moyen de paiement a bien été mis à jour',
      cancelOneClick: 'Je ne souhaite pas bénéficier des offres d\'achat en 1 clic, merci de ne plus me les envoyer',
      enterYourToken: 'Veuillez entrer le code à 6 chiffres',
      tokenIsNotValid: 'Le code ne correspond pas. Veuillez réessayer ou cliquez sur le lien présent dans l\'email',
      weHaveSentItThoughMail: 'Nous l\'avons envoyé par mail à l\'adresse',
      yourOrderIsWellSavedAndFreezedFor30mins: 'Votre commande est bien enregistrée, elle est réservée pendant 30 minutes.',
      paste: 'Coller le code',
      confirm: 'Confirmer',
      cancel: 'Annuler'
    },
    form: {
      choicesForm: 'Votre achat',
      billingForm: 'Vos coordonnées de facturation',
      shippingForm: 'Vos coordonnées de livraison',
      paymentForm: 'Vos informations de paiement',
      cgu: 'J\'accepte les Conditions Générales de Vente',
      email: 'Adresse email',
      emailConfirm: 'Confirmer l\'adresse email',
      gender: 'Civilité',
      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Numéro de téléphone',
      street1: 'Adresse ligne 1', // Not visible
      street2: 'Adresse ligne 2', // Not visible
      street3: 'Adresse ligne 1',
      street4: 'Adresse ligne 2',
      normalizedStreet3: 'Numéro et nom de la voie',
      normalizedStreet1: 'N° Appt - Etage - Couloir - Esc',
      normalizedStreet2: 'Entrée - Bâtiment - Résidence',
      normalizedStreet4: 'Lieu Dit ou service particulier',
      zipCode: 'Code postal',
      city: 'Ville',
      country: 'Pays',
      displayShipping: 'Utiliser la même adresse pour la livraison',
      iAgree: 'J\'accepte les',
      conditions: 'conditions générales de vente {merchant}',
      andThe: 'et les',
      serviceConditions: 'conditions générales de services de paiement Palyance',
      fillForm: 'Veuillez renseigner vos coordonnées et accepter les Conditions Générales de Vente afin de pouvoir accéder au paiement.',
      fillFormMultiple: 'Veuillez sélectionner au moins un produit, renseigner vos coordonnées et accepter les Conditions Générales de Vente afin de pouvoir accéder au paiement.',
      alreadyPurchased: 'Vous avez déjà acheté ce produit.',
      orderCanceled: 'Votre achat a bien été annulé.',
      prefillFailed: 'Impossible de récupérer les informations du Client.',
      regularisationSucceed: 'Le mode de paiement a bien été enregistré.',
      regularizeNotConform: 'Le lien que vous avez utilisé est erroné !',
      regularizePaymentMethod: 'Choisissez votre moyen de paiement',
      recaptureContact: 'Vos informations personnelles',
      recaptureCompleteContact: 'Afin d\'enregistrer votre moyen de paiement il est nécessaire de remplir vos informations personnelles. Une fois saisies, vous pourrez finaliser l\'opération en complétant vos informations de paiement.',
      recaptureContactNotValid: 'Le formulaire n\'est pas complet, merci de renseigner les champs obligatoires.',
      recaptureContactValid: 'Formulaire valide, vous pouvez saisir votre moyen de paiement.',
      regularizeContact: 'Vos informations personnelles',
      warningMessage1click: 'Attention, cliquer sur le bouton ci-dessous valide la commande',
      prefill: 'Préremplir',
      noPrefillThanks: 'Non merci',
      youAreAlreadyPalyanceUser: 'Vous êtes déjà utilisateur de Palyance.',
      useDataLinkedTo: 'Utiliser les données liées à',
      dataLinkedTo: 'Les données liées à',
      haveBeenUsedToFillTheForm: 'ont été utilisées pour remplir le formulaire.',
      youWillBeDeliveredAt: 'Vous serez livré à',
      youWillBeBilledAt: 'Vous serez facturé à',
      editMyAddress: 'Editer mes données',
      thisIsNotMyEmail: 'Ce n\'est pas mon adresse email',
      toFillTheForm: 'pour remplir le formulaire ?'

    },
    billingRecap: {
      title: 'Récapitulatif de votre commande',
      choiceName: 'Nom',
      choiceCode: 'Référence produit',
      description: 'Descriptif',
      paymentAtOrderTime: 'Ce que je règle aujourd\'hui',
      paymentAfterFreeDays: context => `Montant de la commande à régler dans ${context.named('freeDays')} jours`,
      price: 'Prix',
      shippingPrice: 'Frais',
      orderTotal: 'Total',
      paymentMethod: 'Mode de paiement'
    },
    cancelOneClick: {
      cancelOneClickModalSentence1: 'Je ne souhaite pas bénéficier de ma livraison prioritaire et des réductions, cadeaux et ventes privées exclusifs',
      cancelOneClickModalSentence2: 'Je conserve mon abonnement premium, mais refuse la conservation de mes données bancaires',
      cancelOneClickModalSentence3: 'Je ne modifie pas mon offre',
      configSaved: 'Vos préférences ont bien été enregistrées',
      changeOffer: 'Je souhaite modifier mon offre',
      errorMessage: 'Annulez ou sélectionnez une option'
    },
    formValidators: {
      name: 'fr',
      messages: {
        _default: 'Ce champ est obligatoire.',
        excluded: 'Ce champ est obligatoire.',
        min: (field, [length]) => `Ce champ doit contenir au moins ${length} caractères.`,
        max: (field, [length]) => `Ce champ ne peut pas contenir plus de ${length} caractères.`,
        max_value: (field, [max]) => `Ce champ doit contenir un nombre inférieur ou égal à ${max}.`,
        min_value: (field, [min]) => `Ce champ doit contenir un nombre égal ou supérieur à ${min}.`,
        regex: 'La valeur saisie est invalide.',
        required: 'Ce champ est obligatoire.',
        email: 'Veuillez saisir une adresse email valide.',
        confirmed: 'Les adresses email ne correspondent pas.'
      },
      custom: {}
    },
    bankCardErrors: {
      NOT_FOUND: 'Une erreur est survenue lors de votre paiement avec carte.',
      FAIL: 'Une erreur est survenue lors de votre paiement avec carte.',
      UNK: 'Une erreur est survenue lors de votre paiement avec carte.',
      TIMEOUT: 'Une erreur est survenue lors de votre paiement avec carte.'
    }
  },
  en: {
    all: {
      orderForm: 'order form',
      sepa: 'direct debit (SEPA)',
      bank_card: 'credit card',
      price: 'price',
      loading: 'Loading...',
      name: 'name',
      description: 'description',
      paymentMethod: 'payment method',
      shippingPrice: 'shipping fees',
      shippingPriceForYourCountry: 'shipping fees for selected country',
      testSubmitPayment: 'TEST MODE: submit payment',
      cancelOrderConfirmMessage: 'Do you confirm current order cancellation ?',
      paymentErrorMessage: 'An error occurred during the payment process, please try again.',
      defaultValidation1cButtonLabel: 'Click here to confirm that you are human',
      defaultOopsButtonLabel: 'Cancel my order',
      expiredMessage: 'Sorry, your order has already been processed. You cannot modify it anymore...',
      testEnabled: 'You are currently running Vanguard using testLevel=',
      previewEnable: 'Warning: This page is the overview of a currently expired BDC',
      recaptureOk: 'Your payment information\'s has been updated. Thank you.',
      regularizeOk: 'Your payment information\'s has been updated. Thank you.',
      cancelOneClick: 'I don\'t want to receive one click offers anymore',
      enterYourToken: 'Please enter the 6 digit code',
      tokenIsNotValid: 'The code does not match. Please try again or click on the link in the email',
      weHaveSentItThoughMail: 'We sent it by email to the address',
      yourOrderIsWellSavedAndFreezedFor30mins: 'Your order is well registered, it is reserved for 30 minutes.',
      paste: 'Paste the code',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    form: {
      choicesForm: 'Select an item',
      billingForm: 'Billing Information',
      shippingForm: 'Shipping Information',
      paymentForm: 'Payment Information',
      email: 'Email Address',
      emailConfirm: 'Confirm Email Address',
      gender: 'Civility',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone Number',
      street1: 'Address Line 1', // Not visible
      street2: 'Address Line 2', // Not visible
      street3: 'Address Line 1',
      street4: 'Address Line 2',
      normalizedStreet3: 'Street number and name',
      normalizedStreet1: 'Apart. number - Floor - Corridor - Staircase',
      normalizedStreet2: 'Entrance - Building - Residence',
      normalizedStreet4: 'Place Said or particular service',
      zipCode: 'Zip Code',
      city: 'City',
      country: 'Country',
      cgu: 'I agree with Terms and Conditions',
      displayShipping: 'Use the same address for shipping',
      iAgree: 'I agree with',
      conditions: 'Terms and Conditions {merchant}',
      andThe: 'and the',
      serviceConditions: 'Terms and Conditions',
      fillForm: 'Please fill your contact information and check to agree with the Terms and Conditions in order to display payment module.',
      fillFormMultiple: 'Please select at least one product, fill your contact information and check to agree with the Terms and Conditions in order to display payment module.',
      alreadyPurchased: 'You have already purchased this item.',
      orderCanceled: 'Your order has been successfully canceled.',
      prefillFailed: 'Unable to retrieve Customer information.',
      regularisationSucceed: 'The payment method has been saved.',
      regularizeNotConform: 'The link you used is wrong!',
      regularizePaymentMethod: 'Choose your payment method',
      recaptureContact: 'Your personal information',
      recaptureCompleteContact: 'In order to register your payment method it is necessary to fill in your personal information. Once entered, you can finalize the transaction by completing your payment information.',
      recaptureContactNotValid: 'The form is not complete, please fill in the required fields.',
      recaptureContactValid: 'Valid form, you can enter your payment method.',
      regularizeContact: 'Your personal information',
      warningMessage1click: 'Attention, clicking on the button below validates the order',
      prefill: 'Prefill',
      noPrefillThanks: 'No thanks',
      youAreAlreadyPalyanceUser: 'You are already a Palyance user.',
      useDataLinkedTo: 'Use data related to',
      dataLinkedTo: 'The data related to',
      haveBeenUsedToFillTheForm: 'has been used to fill the form.',
      youWillBeDeliveredAt: 'You will be delivered at',
      youWillBeBilledAt: 'You will be billed at',
      editMyAddress: 'Change my address',
      thisIsNotMyEmail: 'This is not my email',
      toFillTheForm: 'to fill out the form?'
    },
    billingRecap: {
      title: 'Summary of your order',
      choiceName: 'Name',
      choiceCode: 'Product sku',
      description: 'Description',
      paymentAtOrderTime: 'Payment at order',
      paymentAfterFreeDays: context => `Amount to pay in ${context.named('freeDays')} days`,
      price: 'Price',
      shippingPrice: 'Fees',
      orderTotal: 'Total',
      paymentMethod: 'Payment method'
    },
    cancelOneClick: {
      cancelOneClickModalSentence1: 'I do not wish to benefit from my priority delivery and exclusive discounts, gifts and private sales',
      cancelOneClickModalSentence2: 'I keep my premium subscription, but refuse to keep my bank details',
      cancelOneClickModalSentence3: 'I do not modify my offer',
      configSaved: 'Your preferences have been saved',
      changeOffer: 'I want to modify my offer',
      errorMessage: 'Cancel or select an option'
    },
    formValidators: {
      name: 'en',
      messages: {
        _default: 'This field is required.',
        excluded: 'This field is required.',
        min: (field, [length]) => `This field must be at least ${length} characters.`,
        max: (field, [length]) => `This field may not be greater than ${length} characters.`,
        max_value: (field, [max]) => `This field must be ${max} or less.`,
        min_value: (field, [min]) => `This field must be ${min} or more.`,
        regex: 'The field value is invalid.',
        required: 'This field is required.',
        email: 'Please type a valid email address.',
        france: 'Please enter a valid postal code. In France, the postal code must contain 5 digits.',
      },
      custom: {}
    },
    bankCardErrors: {
      NOT_FOUND: 'An error occurred while paying with card.',
      FAIL: 'An error occurred while paying with card.',
      UNK: 'An error occurred while paying with card.',
      TIMEOUT: 'An error occurred while paying with card.'
    }
  },
  es: {
    all: {
      orderForm: 'página de pedido',
      sepa: 'mandato SEPA',
      bank_card: 'tarjeta de crédito',
      price: 'precio',
      loading: 'Cargando…',
      name: 'nombre',
      description: 'descripción',
      paymentMethod: 'forma de pago',
      shippingPrice: 'gastos de envío',
      shippingPriceForYourCountry: 'gastos de envío para el país seleccionado',
      testSubmitPayment: 'MODE TEST : simuler paiement',
      cancelOrderConfirmMessage: '¿Desea confirmar la anulación de su pedido?',
      defaultValidation1cButtonLabel: 'Haga clic aquí para confirmar que es humano',
      paymentErrorMessage: 'Se ha producido un error al realizar el pago. Por favor, inténtelo de nuevo.',
      defaultOopsButtonLabel: 'Deseo anular mi pedido anterior.',
      expiredMessage: 'Lo sentimos, su pedido ya ha sido procesado. No lo puede modificar.',
      testEnabled: 'Vous utilisez actuellement Vanguard avec le paramètre testLevel=',
      previewEnable: 'Atención: Esta página es la descripción general de un BDC actualmente vencido',
      recaptureOk: 'Su método de pago ha sido actualizado correctamente',
      regularizeOk: 'Su método de pago ha sido actualizado correctamente',
      cancelOneClick: 'No deseo aprovechar las ofertas con un sólo clic, por favor no me las envíen más',
      enterYourToken: 'Ingrese el código de 6 dígitos',
      tokenIsNotValid: 'El código no coincide. Vuelva a intentarlo o haga clic en el enlace del correo electrónico.',
      weHaveSentItThoughMail: 'Lo enviamos por correo electrónico a la dirección',
      yourOrderIsWellSavedAndFreezedFor30mins: 'Su pedido está bien registrado, está reservado por 30 minutos.',
      paste: 'Pegar el código',
      confirm: 'Confirmar',
      cancel: 'Cancelar'
    },
    form: {
      choicesForm: 'Su compra',
      billingForm: 'Sus datos de facturación',
      shippingForm: 'Sus datos de entrega',
      paymentForm: 'Sus informaciones de pago',
      cgu: 'Acepto las condiciones generales de venta',
      email: 'Email',
      emailConfirm: 'Confirmación de email',
      gender: 'Civilidad',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      phone: 'Número de teléfono',
      street1: 'Dirección 1', // Not visible
      street2: 'Dirección 2', // Not visible
      street3: 'Dirección 1',
      street4: 'Dirección 2',
      normalizedStreet3: 'Número y nombre de la calle',
      normalizedStreet1: 'N° de apart - Piso - Pasillo - Esca',
      normalizedStreet2: 'Entrada - Edificio - Residencia',
      normalizedStreet4: 'Lugar dicho o servicio particular',
      zipCode: 'Código Postal',
      city: 'Ciudad',
      country: 'País',
      displayShipping: 'Utilizar la misma dirección para la entrega',
      iAgree: 'Acepto las',
      conditions: 'condiciones generales de venta {merchant}',
      andThe: 'y las',
      serviceConditions: 'condiciones generales de servicio',
      fillForm: 'Por favor, rellene sus datos y acepte las Condiciones Generales de Venta para poder proceder con el pago.',
      fillFormMultiple: 'Por favor, seleccione al menos 1 producto, rellene sus datos y acepte las Condiciones Generales de Venta para poder proceder con el pago.',
      alreadyPurchased: 'Usted ya ha comprado este producto.',
      orderCanceled: 'Se ha anulado correctamente su compra.',
      prefillFailed: 'No se puede recuperar la información del cliente.',
      regularisationSucceed: 'Se ha guardado el método de pago.',
      regularizeNotConform: '¡El enlace que usaste es incorrecto!',
      regularizePaymentMethod: 'Escoja su método de pago',
      recaptureContact: 'Tu información personal',
      recaptureCompleteContact: 'Para registrar su método de pago es necesario completar su información personal. Una vez ingresada, puede finalizar la transacción completando su información de pago.',
      recaptureContactNotValid: 'El formulario no está completo, por favor complete los campos requeridos.',
      recaptureContactValid: 'Forma válida, puede ingresar su forma de pago.',
      regularizeContact: 'Tu información personal',
      warningMessage1click: 'Atención, al hacer clic en el botón de abajo se valida el pedido',
      prefill: 'Prellenado',
      noPrefillThanks: 'No gracias',
      youAreAlreadyPalyanceUser: 'Ya eres usuario de Palyance.',
      useDataLinkedTo: 'Utilice datos relacionados con',
      dataLinkedTo: 'Datos relacionados con',
      haveBeenUsedToFillTheForm: 'se utilizaron para completar el formulario.',
      youWillBeDeliveredAt: 'Serás entregado a',
      youWillBeBilledAt: 'Se le facturará a',
      editMyAddress: 'Editar mi direccion',
      thisIsNotMyEmail: 'Este no es mi email',
      toFillTheForm: 'para llenar el formulario?'
    },
    billingRecap: {
      title: 'Resumen de su pedido',
      choiceName: 'Nombre',
      choiceCode: 'Referencia del producto',
      description: 'Descripción',
      paymentAtOrderTime: 'Lo que pago hoy',
      paymentAfterFreeDays: context => `Monto del pedido a pagar en ${context.named('freeDays')} días`,
      price: 'Precio',
      shippingPrice: 'Gastos de envío',
      orderTotal: 'Total',
      paymentMethod: 'Modo de pago'
    },
    cancelOneClick: {
      cancelOneClickModalSentence1: 'No deseo beneficiarme de mi entrega prioritaria y descuentos exclusivos, regalos y ventas privadas',
      cancelOneClickModalSentence2: 'Conservo mi suscripción premium, pero no quiero que se almacenen mis datos bancarios',
      cancelOneClickModalSentence3: 'No modifico mi oferta',
      configSaved: 'Sus preferencias han sido guardadas',
      changeOffer: 'Me gustaría cambiar mi oferta',
      errorMessage: 'Cancelar o seleccionar una opción'
    },
    formValidators: {
      name: 'es',
      messages: {
        _default: 'Este campo es obligatorio.',
        excluded: 'Este campo es obligatorio.',
        min: (field, [length]) => `Este campo debe contener al menos ${length} caracteres.`,
        max: (field, [length]) => `Este campo no debe contener más de ${length} caracteres.`,
        max_value: (field, [max]) => `Este campo debe contener un número inferior o igual a ${max}.`,
        min_value: (field, [min]) => `Este campo debe contener un número igual o superior a ${min}.`,
        regex: 'El valor introducido no es válido.',
        required: 'Este campo es obligatorio.',
        email: 'Introduzca una dirección de correo electrónico válida.',
        confirmed: 'Las direcciones de correo electrónico no corresponden.',
        france: 'Introduzca un código postal válido. En Francia, el código postal debe contener 5 dígitos.'
      },
      custom: {}
    },
    bankCardErrors: {
      NOT_FOUND: 'Se produjo un error al pagar con tarjeta.',
      FAIL: 'Se produjo un error al pagar con tarjeta.',
      UNK: 'Se produjo un error al pagar con tarjeta.',
      TIMEOUT: 'Se produjo un error al pagar con tarjeta.'
    }
  },
  it: {
    all: {
      orderForm: 'modulo d’ordine',
      sepa: 'mandato SEPA',
      bank_card: 'carta di credito',
      price: 'prezzo',
      loading: 'caricamento...',
      name: 'nome',
      description: 'descrizione',
      paymentMethod: 'metodo di pagamento',
      shippingPrice: 'spese',
      shippingPriceForYourCountry: 'spese di spedizione per il paese selezionato',
      testSubmitPayment: 'MODO TEST : simulare pagamento',
      defaultValidation1cButtonLabel: 'Clicca qui per confermare che sei umano',
      cancelOrderConfirmMessage: 'Confermate l\'annullamento del vostro acquisto ?',
      paymentErrorMessage: 'Un errore è avvenuto durante il pagamento. Grazie di riprovare',
      defaultOopsButtonLabel: 'Annullo il mio acquisto precedente',
      expiredMessage: 'Siamo spiacenti, il vostro acquisto è già stato trattato. Non potete più modificarlo',
      testEnabled: 'Utilizzate attualmente Vanguard con il parametro testLevel=',
      previewEnable: 'Attenzione: Questa pagina è la panoramica di un BDC attualmente scaduto',
      recaptureOk: 'Il vostro metodo di pagamento è stato aggiornato',
      regularizeOk: 'Il vostro metodo di pagamento è stato aggiornato',
      cancelOneClick: 'Non desidero beneficiare di offerte d’acquisto in 1 clic, grazie di non inviarne',
      enterYourToken: 'Si prega di inserire il codice a 6 cifre',
      tokenIsNotValid: 'Il codice non corrisponde. Si prega di riprovare o fare clic sul collegamento nell\'e-mail',
      weHaveSentItThoughMail: 'Lo abbiamo inviato via e-mail all\'indirizzo',
      yourOrderIsWellSavedAndFreezedFor30mins: 'Il tuo ordine è ben registrato, è riservato per 30 minuti.',
      paste: 'Incolla il codice',
      confirm: 'Confermare',
      cancel: 'Annulla'
    },
    form: {
      choicesForm: 'Vostro acquisto',
      billingForm: 'Vostro recapito di fatturazione',
      shippingForm: 'Vostro recapito di consegna',
      paymentForm: 'Le vostre informazioni di pagamento',
      cgu: 'Accetto le Condizioni Generali di Vendita',
      email: 'Indirizzo email',
      emailConfirm: 'Confermare l’indirizzo email',
      gender: 'Civiltà',
      firstName: 'Nome',
      lastName: 'Cognome',
      phone: 'Numero di telefono',
      street1: 'Indirizzo linea 1', // Not visible
      street2: 'Indirizzo linea 2', // Not visible
      street3: 'Indirizzo linea 1',
      street4: 'Indirizzo linea 2',
      normalizedStreet3: 'Numero e nome della via',
      normalizedStreet1: 'N° App - Piano - Corridoio',
      normalizedStreet2: 'Entrata - Palazzo - Residenza',
      normalizedStreet4: 'Luogo Detto',
      zipCode: 'Codice postale',
      city: 'Città',
      country: 'Paese',
      displayShipping: 'Usare lo stesso indirizzo per la consegna ',
      iAgree: 'Accetto le',
      conditions: 'condizioni generali di vendita {merchant}',
      andThe: 'e le',
      serviceConditions: 'condizioni generali di servizio',
      fillForm: 'Vogliate compilare il vostro recapito e accettare le Condizioni Generali di Vendita per accedere al pagamento',
      fillFormMultiple: 'Vogliate selezionare almeno un prodotto, compilare il vostro recapito e accettare le Condizioni Generali di Vendita per accedere al pagamento',
      alreadyPurchased: 'Avete già acquistato questo prodotto ',
      orderCanceled: 'Il vostro acquisto è stato annullato',
      prefillFailed: 'Impossibile di recuperare le informazioni Clienti.',
      regularisationSucceed: 'Il metodo di pagamento è stato registrato',
      regularizeNotConform: 'Il link che avete usato è errato',
      regularizePaymentMethod: 'Scegliete il vostro metodo di pagamento',
      regularizeContact: 'Vostre informazioni personali',
      warningMessage1click: 'Attenzione, cliccare sul pulsante qui sotto per convalidare il vostro acquisto ',
      prefill: 'Pre-riempimento',
      noPrefillThanks: 'No grazie',
      youAreAlreadyPalyanceUser: 'Sei già un utente Palyance.',
      useDataLinkedTo: 'Usa dati relativi a',
      dataLinkedTo: 'I dati relativi a',
      haveBeenUsedToFillTheForm: 'è stato utilizzato per compilare il modulo.',
      youWillBeDeliveredAt: 'Sarai consegnato a',
      youWillBeBilledAt: 'Sarà fatturato a',
      editMyAddress: 'Cambia il mio indirizzo',
      thisIsNotMyEmail: 'Questa non è la mia email',
      toFillTheForm: 'per compilare il modulo?'
    },
    billingRecap: {
      title: 'Riepilogo del vostro ordine ',
      choiceName: 'Nome',
      choiceCode: 'Riferimento prodotto',
      description: 'Descrizione',
      paymentAtOrderTime: 'Quello che pago oggi',
      paymentAfterFreeDays: context => `Importo dell’ordine da pagare in ${context.named('freeDays')} giorni`,
      price: 'Prezzo',
      shippingPrice: 'Spese',
      orderTotal: 'Totale',
      paymentMethod: 'Metodo di pagamento'
    },
    cancelOneClick: {
      cancelOneClickModalSentence1: 'Non desidero beneficiare della mia consegna prioritaria e di sconti esclusivi, regali e vendite private',
      cancelOneClickModalSentence2: 'Conservo il mio abbonamento premium, ma mi rifiuto di conservare i miei dati bancari',
      cancelOneClickModalSentence3: 'Non modifico la mia offerta',
      configSaved: 'Le tue preferenze sono state salvate',
      changeOffer: 'Voglio modificare la mia offerta',
      errorMessage: 'Annulla o seleziona un\'opzione'
    },
    formValidators: {
      name: 'it',
      messages: {
        _default: 'Questo campo è obbligatorio',
        excluded: 'Questo campo è obbligatorio',
        min: (field, [length]) => `Questo campo deve contenere almeno ${length} caratteri.`,
        max: (field, [length]) => `Questo campo deve contenere più di ${length} caratteri.`,
        max_value: (field, [max]) => `Questo campo non può contenere un numero inferiore o uguale a  ${max}.`,
        min_value: (field, [min]) => `Questo campo non può contenere un numero uguale o superiore a  ${min}.`,
        regex: 'Il valore indicato non è valido',
        required: 'Questo campo è obbligatorio',
        email: 'Vogliate indicare un indirizzo email valido ',
        confirmed: 'Gli indirizzi email non corrispondono .'
      },
      custom: {}
    }
  },
  de: {
    all: {
      orderForm: 'order form',
      sepa: 'direct debit (SEPA)',
      bank_card: 'credit card',
      price: 'price',
      loading: 'Loading...',
      name: 'name',
      description: 'description',
      paymentMethod: 'payment method',
      shippingPrice: 'shipping fees',
      shippingPriceForYourCountry: 'shipping fees for selected country',
      testSubmitPayment: 'TEST MODE: submit payment',
      defaultValidation1cButtonLabel: 'Click here to confirm that you are human',
      cancelOrderConfirmMessage: 'Do you confirm current order cancellation ?',
      paymentErrorMessage: 'An error occurred during the payment process, please try again.',
      defaultOopsButtonLabel: 'Cancel my order',
      expiredMessage: 'Sorry, your order has already been processed. You cannot modify it anymore...',
      testEnabled: 'You are currently running Vanguard using testLevel=',
      previewEnable: 'Warning: This page is the overview of a currently expired BDC',
      recaptureOk: 'Your payment information\'s has been updated. Thank you.',
      regularizeOk: 'Your payment information\'s has been updated. Thank you.',
      cancelOneClick: 'I don\'t want to receive one click offers anymore',
      enterYourToken: 'Please enter the 6 digit code',
      tokenIsNotValid: 'The code does not match. Please try again or click on the link in the email',
      weHaveSentItThoughMail: 'We sent it by email to the address',
      yourOrderIsWellSavedAndFreezedFor30mins: 'Your order is well registered, it is reserved for 30 minutes.',
      paste: 'Paste the code',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    form: {
      choicesForm: 'Select an item',
      billingForm: 'Billing Information',
      shippingForm: 'Shipping Information',
      paymentForm: 'Payment Information',
      email: 'Email',
      emailConfirm: 'E-Mail-Bestätigen',
      gender: 'Civility',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefonnummer',
      street1: 'Address Line 1', // Not visible
      street2: 'Address Line 2', // Not visible
      street3: 'Address Line 1',
      street4: 'Address Line 2',
      normalizedStreet3: 'Hausnummer und Name',
      normalizedStreet1: 'Ein Teil. Nummer - Etage - Korridor - Treppe',
      normalizedStreet2: 'Eingang - Gebäude - Residenz',
      normalizedStreet4: 'Adresszusatz',
      zipCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      cgu: 'Ich bin mit den {merchant} Allgemeinen Geschäftsbedingungen einverstanden',
      displayShipping: 'Use the same address for shipping',
      iAgree: 'Ich bin mit den',
      conditions: '{merchant} Allgemeinen Geschäftsbedingungen einverstanden',
      andThe: 'und den',
      serviceConditions: 'Allgemeinen Geschäftsbedingungen einverstanden',
      fillForm: 'Bitte geben Sie Ihre Kontaktinformationen ein und stimmen Sie den Allgemeinen Geschäftsbedingungen zu, um das Zahlungsmodul anzuzeigen.',
      fillFormMultiple: 'Please select at least one product, fill your contact information and check to agree with the Terms and Conditions in order to display payment module.',
      alreadyPurchased: 'You have already purchased this item.',
      orderCanceled: 'Your order has been successfully canceled.',
      prefillFailed: 'Unable to retrieve Customer information.',
      regularisationSucceed: 'The payment method has been saved.',
      regularizeNotConform: 'The link you used is wrong!',
      regularizePaymentMethod: 'Choose your payment method',
      recaptureContact: 'Your personal information',
      recaptureCompleteContact: 'In order to register your payment method it is necessary to fill in your personal information. Once entered, you can finalize the transaction by completing your payment information.',
      recaptureContactNotValid: 'The form is not complete, please fill in the required fields.',
      recaptureContactValid: 'Valid form, you can enter your payment method.',
      regularizeContact: 'Your personal information',
      warningMessage1click: 'Attention, clicking on the button below validates the order',
      prefill: 'Prefill',
      noPrefillThanks: 'No thanks',
      youAreAlreadyPalyanceUser: 'You are already a Palyance user.',
      useDataLinkedTo: 'Use data related to',
      dataLinkedTo: 'The data related to',
      haveBeenUsedToFillTheForm: 'has been used to fill the form.',
      youWillBeDeliveredAt: 'You will be delivered at',
      youWillBeBilledAt: 'Sie werden abgerechnet bei',
      editMyAddress: 'Change my address',
      thisIsNotMyEmail: 'This is not my email',
      toFillTheForm: 'to fill out the form?'
    },
    billingRecap: {
      title: 'Zusammenfassung Ihrer Bestellung',
      choiceName: 'Name',
      choiceCode: 'Product sku',
      description: 'Beschreibung',
      paymentAtOrderTime: 'Zahlung bei Bestellung',
      paymentAfterFreeDays: context => `Zu zahlender Betrag in ${context.named('freeDays')} Tagen`,
      price: 'Preis',
      shippingPrice: 'Fees',
      orderTotal: 'Total',
      paymentMethod: 'Zahlungsmethode'
    },
    cancelOneClick: {
      cancelOneClickModalSentence1: 'I do not wish to benefit from my priority delivery and exclusive discounts, gifts and private sales',
      cancelOneClickModalSentence2: 'I keep my premium subscription, but refuse to keep my bank details',
      cancelOneClickModalSentence3: 'I do not modify my offer',
      configSaved: 'Your preferences have been saved',
      changeOffer: 'I want to modify my offer',
      errorMessage: 'Cancel or select an option'
    },
    formValidators: {
      name: 'en',
      messages: {
        _default: 'This field is required.',
        excluded: 'This field is required.',
        min: (field, [length]) => `This field must be at least ${length} characters.`,
        max: (field, [length]) => `This field may not be greater than ${length} characters.`,
        max_value: (field, [max]) => `This field must be ${max} or less.`,
        min_value: (field, [min]) => `This field must be ${min} or more.`,
        regex: 'The field value is invalid.',
        required: 'This field is required.',
        email: 'Please type a valid email address.'
      },
      custom: {}
    },
    bankCardErrors: {
      NOT_FOUND: 'An error occurred while paying with card.',
      FAIL: 'An error occurred while paying with card.',
      UNK: 'An error occurred while paying with card.',
      TIMEOUT: 'An error occurred while paying with card.'
    }
  }
};



// WEBPACK FOOTER //
// ./i18n/messages.js